//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createRefetchContainer } from "react-relay";
// flow-state-poller imports
import { IContainer, IProps, IState } from "./FlowStatePoller.d";
import { flowStatePollerFragments, flowStatePollerQuery } from "./FlowStatePoller.gql";

//////////////////
// COMPONENT
//////////////////
class FlowStatePollerCmpt extends React.Component<IProps, IState> {
  private flowStateInterval?: ReturnType<typeof setInterval>;

  constructor(props: IProps) {
    super(props);
  }

  // LIFECYCLE
  public componentDidMount = () => {
    this.props.onFlowStateUpdate(this.props.flowState);

    this.flowStateInterval = setInterval(() => {
      this.props.relay.refetch(
        { flowStateRelayId: this.props.flowState.id },
        {},
        (error) => {
          if (error) {
            this.props.onFlowStateUpdate(undefined, error);
          }
        },
        { force: true },
      );
    }, 10000);
  };

  public componentDidUpdate = (prevProps: IProps) => {
    if (
      prevProps.flowState !== this.props.flowState &&
      !this.props.flowState.current.errorMessage
    ) {
      this.props.onFlowStateUpdate(this.props.flowState);
    }

    if (this.props.flowState.current.errorMessage && this.flowStateInterval) {
      clearInterval(this.flowStateInterval);

      delete this.flowStateInterval;
    }
  };

  public componentWillUnmount = () => {
    if (this.flowStateInterval) {
      clearInterval(this.flowStateInterval);

      delete this.flowStateInterval;
    }
  };

  public render() {
    return null; // this component exists purely as a non-visual refetch container
  }
}

//////////////////
// RELAY
//////////////////
export const FlowStatePoller = createRefetchContainer<IContainer>(
  FlowStatePollerCmpt,
  flowStatePollerFragments,
  flowStatePollerQuery,
);
